import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, CanActivateChild, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from './../services/auth.service';
​
@Injectable({
providedIn: 'root'
})

export class AuthGuard implements CanActivateChild {
	constructor(
		private authService: AuthService, 
		private router: Router){};
	​
	canActivateChild(
		next: ActivatedRouteSnapshot,
		state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
		
		const token = localStorage.getItem('token');
		return new Observable<boolean>( observer => { 
			this.authService.decodeJWT(token).subscribe((
				(res:any) => {
					if (res.success){
						observer.next(true);
					}
					else{
						this.router.navigate(['/bo/connexion']);
						observer.next(false);
					}   
				}
			));
		});
	}
}